import { connect } from "react-redux";
import { utcOffset } from "../../utils/time";
import setSystemTimezone from "../../store/epics/setSystemTimezone";
import updateTimezone from "../../store/epics/updateTimezone";
import { TRACK_EDIT_TIMEZONE, callOnlyOnce } from "../../store/mixpanel";

export default connect(
  ({
    user: {
      data: { _id, timezone = utcOffset(), tutorial_status }
    }
  }) => ({ _id, timezone, tutorial_status }),
  dispatch => {
    const trackTz = callOnlyOnce(timezone => {
      dispatch({
        type: TRACK_EDIT_TIMEZONE,
        payload: { timezone, from: "modal" }
      });
    });
    return {
      updateTimezone(timezone) {
        trackTz();
        return dispatch(updateTimezone({ timezone }));
      },
      setSystemTimezone() {
        return dispatch(setSystemTimezone());
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/components/ZoneSelect/connected.js